import { render } from "./cartClientTable.vue?vue&type=template&id=a99df156&scoped=true&ts=true"
import script from "./cartClientTable.vue?vue&type=script&lang=ts"
export * from "./cartClientTable.vue?vue&type=script&lang=ts"

import "./cartClientTable.vue?vue&type=style&index=0&id=a99df156&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a99df156"]])

export default __exports__